import { render } from "./AttachementComp.vue?vue&type=template&id=662a3896"
import script from "./AttachementComp.vue?vue&type=script&lang=js"
export * from "./AttachementComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__